import React from 'react';
import {useTranslation} from 'react-i18next';
import {RadioGroup, SecondaryButton} from "@careers-wales/react-components";

function StagedQuestion(props) {
    const {t} = useTranslation();


    return (
        <>
        {(!props.answers[props.currentStage] || !props.answers[props.currentStage][0] || !props.answers[props.currentStage][1]) &&  <> <p><strong> {props.question.category}</strong></p>
            <p>{props.question.instructions[0]}</p></>}
            <p><strong>{t('view.stages.firstChoice')}</strong></p>
            {!props.answers[props.currentStage] || !props.answers[props.currentStage][0] ?


                <RadioGroup
                    groupClasses={['radios--custom-d', 'no-legend']}
                    options={
                    props.question.answers.map((item) => {
                        return {
                            "id": item.dmqResponseId,
                            "text": item.response,
                            "isHidden": false
                        }
                    })

                }
                            isHidden={false}
                            value={props.answers[props.currentStage] ? props.answers[props.currentStage][0] : ''}
                            onChange={(value) => {
                                props.setValidationError(false);
                                let existingAnswers = [...props.answers];
                                if (!existingAnswers[props.currentStage]) {
                                    existingAnswers[props.currentStage] = [];
                                }
                                existingAnswers[props.currentStage][0] = value;

                                props.setAnswers(existingAnswers);

                            }}
                /> :
                <div className={"selected-input-panel"}>{props.getAnswerByStageId(props.currentStage, props.answers[props.currentStage][0]).response}</div>
            }


            {props.answers[props.currentStage] && props.answers[props.currentStage][0] && <div>
                <p><strong>{t('view.stages.secondChoice')}</strong></p>
                {!props.answers[props.currentStage][1] ?
                    <div><p>{props.question.instructions[1]}</p>


                        <RadioGroup
                            groupClasses={['radios--custom-d', 'no-legend']}
                            options={
                            props.question.answers.filter(x => x.dmqResponseId !== props.answers[props.currentStage][0]).map((item) => {

                                return {
                                    "id": item.dmqResponseId,
                                    "text": item.response,
                                    "isHidden": false
                                }
                            })

                        }

                                    isHidden={false}
                                    value={props.answers[props.currentStage] ? props.answers[props.currentStage][1] : ''}
                                    onChange={(value) => {
                                        props.setValidationError(false);
                                        let existingAnswers = [...props.answers];
                                        if (!existingAnswers[props.currentStage]) {
                                            existingAnswers[props.currentStage] = [];
                                        }
                                        existingAnswers[props.currentStage][1] = value;

                                        props.setAnswers(existingAnswers);

                                    }}
                        /></div> :
                    <div className={"selected-input-panel"}>{props.getAnswerByStageId(props.currentStage, props.answers[props.currentStage][1]).response}</div>}
            </div>}


            {props.answers[props.currentStage] &&  <SecondaryButton
                ariaLabel={t('styleguide:forms.clearAllChoices')}
                onPress={(event) => {
                    let existingAnswers = [...props.answers];
                    existingAnswers[props.currentStage] = [];
                    props.setAnswers(existingAnswers);
                }}
            >{t('styleguide:forms.clearAll')}</SecondaryButton>}

        </>
    );
}

export default StagedQuestion;
